import {motion} from 'framer-motion';
import NavIcon from './NavIcon';
import { IoArrowBackOutline } from "react-icons/io5";

function FullScreenCard({
    children,
    cardClass = defaultValues.cardClass,
    hasBackNavigation = defaultValues.hasBackNavigation,
    backNavigationFunction = defaultValues.backNavigationFunction,
    backNavigationTarget = defaultValues.backNavigationTarget
}) {
    return (
        <motion.div
        initial={{maxWidth: '0vw', opacity: 0, x: -1000}}
        animate={{maxWidth: '100vw', opacity: 1, x: 0}}
        exit={{maxWidth: '0vw', opacity: 0, x: -1000}}
        transition={{duration: 1}}
        className={cardClass}>
            <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0, transition: {duration: 0.3, delay: 0}}}
            transition={{duration: 0.5, delay: 1}}>
                {hasBackNavigation === true ?
                    <NavIcon buttonFunction={backNavigationFunction} buttonArguments={backNavigationTarget} divClass={'backButton'}>
                        <IoArrowBackOutline size='25' color='#3D3D3D'/>
                    </NavIcon> : null
                }
                {children}
                <br />
                <br />
                <br />
            </motion.div>
        </motion.div>
      )
}

const emptyFunction = () => {}

const defaultValues = {
    cardClass: "fullscreenCard",
    hasBackNavigation: false,
    backNavigationTarget: '',
    backNavigationFunction: emptyFunction
}

export default FullScreenCard